import styled from '@emotion/styled';
import { ImageNotSupported } from '@mui/icons-material';
import { Box as MuiBox, BoxProps as MuiBoxProps, Typography } from '@mui/material';
import { CSSProperties } from '@mui/styled-engine';
import { FC, PropsWithChildren, useMemo } from 'react';

export interface BoxProps extends MuiBoxProps {
	overflowX?: CSSProperties['overflowX'];
}

export function Box(props: BoxProps) {
	const sx = useMemo(() => ({ ...props.sx, overflowX: props.overflowX }), [props.sx, props.overflowX]);
	return <MuiBox display="flex" flexDirection="column" justifyContent="center" {...props} sx={sx}></MuiBox>;
}

export function Col(props: BoxProps) {
	return <Box display="flex" flexDirection="column" justifyContent="center" {...props}></Box>;
}

export function Row(props: BoxProps) {
	return <Box display="flex" flexDirection="row" alignItems="center" {...props}></Box>;
}

export function Spacer(props: BoxProps) {
	return <Box flex="1 0" {...props}></Box>;
}

export type FCC<T extends object = {}> = FC<PropsWithChildren & T>;

export const Text = Typography;

export const Title = styled('div')({
	flex: 1,
	textAlign: 'left',
	fontWeight: 'bold',
	marginRight: 10,
	whiteSpace: 'nowrap',
});

export const Value = styled('div')({
	flex: 1,
	textAlign: 'right',
	whiteSpace: 'nowrap',
});

const Img = styled('img')({
	maxWidth: '100%',
	maxHeight: '200px',
	objectFit: 'contain',
	marginBottom: 8,
});

export const Image: FC<{
	src?: string;
	alt?: string;
	width?: number;
	height?: number;
	style?: React.CSSProperties;
}> = ({ src, alt, width = 'auto', height = 'auto', style }) => {
	if (!src) return <ImageNotSupported sx={{ width, height }} color="disabled" />;
	return <Img src={src} alt={alt} style={{ width, height, ...style }} />;
};
